export default (items: $TSMigrationFixMe) =>
  items?.map((contacto: $TSMigrationFixMe) => ({
    razonSocial: contacto?.razonSocial,
    nif: contacto?.nif,
    direccion: contacto?.direccion,
    calle: contacto?.direccion?.calle,
    telefono: contacto?.telefonos?.[0]?.contacto,
    email: contacto?.emails?.[0]?.contacto,
    empresaId: contacto?.empresaId,
    id: contacto?.clienteProveedorId,
    ...contacto,
  }))
